import { render } from "./user_message_list.vue?vue&type=template&id=c600c190&scoped=true&ts=true"
import script from "./user_message_list.vue?vue&type=script&lang=ts"
export * from "./user_message_list.vue?vue&type=script&lang=ts"

import "./user_message_list.vue?vue&type=style&index=0&id=c600c190&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c600c190"]])

export default __exports__